export default __webpack_public_path__ + "static/media/Greenpea.bac8497e.jpg";